import { render } from "./SFlowOneHeader.vue?vue&type=template&id=cef4dc54&scoped=true"
import script from "./SFlowOneHeader.vue?vue&type=script&lang=js"
export * from "./SFlowOneHeader.vue?vue&type=script&lang=js"

import "./SFlowOneHeader.vue?vue&type=style&index=0&id=cef4dc54&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef4dc54"]])

export default __exports__